var createHistory = require('history').createBrowserHistory

export default createHistory({
  /* pass a configuration object here if needed */
})
